import { Divider } from '@chakra-ui/react'
import React, { FC } from 'react'
import { useColor } from '../../theme'

/**
 * Divider for the header popover list.
 */
export const HeaderPopoverListDivider: FC = () => {
  const dividerColor = useColor({ nuance: 2, palette: 'secondary' })

  return (
    <Divider
      borderColor={dividerColor}
      data-testid="header-popover-list-divider"
    />
  )
}
